import { EditText } from '../../../../../../component/ui/edit-text/edit-text';
import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { saveNewAssignmentTypeOperation } from '../operations/save-new-assignment-type-operation';

interface AddNewAssignmentTypeDialogDatamodel {
  onHide: () => any;
}
export const AddNewAssignmentTypeDialog: React.FC<
  AddNewAssignmentTypeDialogDatamodel
> = ({ onHide }) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handeOnApprove = async () => {
    await saveNewAssignmentTypeOperation(name, setLoading, onHide);
  };

  return (
    <div>
      <EditText onChange={setName} value={name} title={'שם סוג המטלה'} />
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          onClick={handeOnApprove}
          loading={loading}
          style={{ height: '30px' }}
          label={'אישור'}
        />
      </div>
    </div>
  );
};
